"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var Canvas_1 = require("./Canvas");

var Particles_1 = require("./Particles");

var Retina_1 = require("./Retina");

var FrameManager_1 = require("./FrameManager");

var Options_1 = require("../Options/Classes/Options");

var Utils_1 = require("../Utils");

var Vector_1 = require("./Particle/Vector");

var Container = /*#__PURE__*/function () {
  function Container(id, sourceOptions) {
    var _this = this;

    _classCallCheck(this, Container);

    this.id = id;
    this.zLayers = 10000;
    this.fpsLimit = 60;
    this.duration = 0;
    this.lifeTime = 0;
    this.firstStart = true;
    this.started = false;
    this.destroyed = false;
    this.paused = true;
    this.lastFrameTime = 0;
    this.pageHidden = false;
    this._sourceOptions = sourceOptions;
    this.retina = new Retina_1.Retina(this);
    this.canvas = new Canvas_1.Canvas(this);
    this.particles = new Particles_1.Particles(this);
    this.drawer = new FrameManager_1.FrameManager(this);
    this.pathGenerator = {
      generate: function generate() {
        var v = Vector_1.Vector.create(0, 0);
        v.length = Math.random();
        v.angle = Math.random() * Math.PI * 2;
        return v;
      },
      init: function init() {},
      update: function update() {}
    };
    this.interactivity = {
      mouse: {
        clicking: false,
        inside: false
      }
    };
    this.bubble = {};
    this.repulse = {
      particles: []
    };
    this.attract = {
      particles: []
    };
    this.plugins = new Map();
    this.drawers = new Map();
    this.density = 1;
    this._options = new Options_1.Options();
    this.actualOptions = new Options_1.Options();

    for (var _len = arguments.length, presets = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      presets[_key - 2] = arguments[_key];
    }

    for (var _i = 0, _presets = presets; _i < _presets.length; _i++) {
      var preset = _presets[_i];

      this._options.load(Utils_1.Plugins.getPreset(preset));
    }

    var shapes = Utils_1.Plugins.getSupportedShapes();

    var _iterator = _createForOfIteratorHelper(shapes),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        var drawer = Utils_1.Plugins.getShapeDrawer(type);

        if (drawer) {
          this.drawers.set(type, drawer);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (this._options) {
      this._options.load(this._sourceOptions);
    }

    this.eventListeners = new Utils_1.EventListeners(this);

    if (typeof IntersectionObserver !== "undefined" && IntersectionObserver) {
      this.intersectionObserver = new IntersectionObserver(function (entries) {
        return _this.intersectionManager(entries);
      });
    }
  }

  _createClass(Container, [{
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "sourceOptions",
    get: function get() {
      return this._sourceOptions;
    }
  }, {
    key: "play",
    value: function play(force) {
      var needsUpdate = this.paused || force;

      if (this.firstStart && !this.actualOptions.autoPlay) {
        this.firstStart = false;
        return;
      }

      if (this.paused) {
        this.paused = false;
      }

      if (needsUpdate) {
        var _iterator2 = _createForOfIteratorHelper(this.plugins),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                plugin = _step2$value[1];

            if (plugin.play) {
              plugin.play();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.draw(needsUpdate || false);
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.drawAnimationFrame !== undefined) {
        Utils_1.cancelAnimation()(this.drawAnimationFrame);
        delete this.drawAnimationFrame;
      }

      if (this.paused) {
        return;
      }

      var _iterator3 = _createForOfIteratorHelper(this.plugins),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              plugin = _step3$value[1];

          if (plugin.pause) {
            plugin.pause();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (!this.pageHidden) {
        this.paused = true;
      }
    }
  }, {
    key: "draw",
    value: function draw(force) {
      var _this2 = this;

      var refreshTime = force;
      this.drawAnimationFrame = Utils_1.animate()(function (timestamp) {
        if (refreshTime) {
          _this2.lastFrameTime = undefined;
          refreshTime = false;
        }

        _this2.drawer.nextFrame(timestamp);
      });
    }
  }, {
    key: "getAnimationStatus",
    value: function getAnimationStatus() {
      return !this.paused && !this.pageHidden;
    }
  }, {
    key: "setNoise",
    value: function setNoise(noiseOrGenerator, init, update) {
      this.setPath(noiseOrGenerator, init, update);
    }
  }, {
    key: "setPath",
    value: function setPath(pathOrGenerator, init, update) {
      if (!pathOrGenerator) {
        return;
      }

      if (typeof pathOrGenerator === "function") {
        this.pathGenerator.generate = pathOrGenerator;

        if (init) {
          this.pathGenerator.init = init;
        }

        if (update) {
          this.pathGenerator.update = update;
        }
      } else {
        if (pathOrGenerator.generate) {
          this.pathGenerator.generate = pathOrGenerator.generate;
        }

        if (pathOrGenerator.init) {
          this.pathGenerator.init = pathOrGenerator.init;
        }

        if (pathOrGenerator.update) {
          this.pathGenerator.update = pathOrGenerator.update;
        }
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stop();
      this.canvas.destroy();

      var _iterator4 = _createForOfIteratorHelper(this.drawers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              drawer = _step4$value[1];

          if (drawer.destroy) {
            drawer.destroy(this);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(this.drawers.keys()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          this.drawers.delete(key);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.destroyed = true;
    }
  }, {
    key: "exportImg",
    value: function exportImg(callback) {
      this.exportImage(callback);
    }
  }, {
    key: "exportImage",
    value: function exportImage(callback, type, quality) {
      var _a;

      return (_a = this.canvas.element) === null || _a === void 0 ? void 0 : _a.toBlob(callback, type !== null && type !== void 0 ? type : "image/png", quality);
    }
  }, {
    key: "exportConfiguration",
    value: function exportConfiguration() {
      return JSON.stringify(this.actualOptions, undefined, 2);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.stop();
      return this.start();
    }
  }, {
    key: "reset",
    value: function reset() {
      this._options = new Options_1.Options();
      return this.refresh();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.started) {
        return;
      }

      this.firstStart = true;
      this.started = false;
      this.eventListeners.removeListeners();
      this.pause();
      this.particles.clear();
      this.canvas.clear();

      if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
        this.intersectionObserver.observe(this.interactivity.element);
      }

      var _iterator6 = _createForOfIteratorHelper(this.plugins),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              plugin = _step6$value[1];

          if (plugin.stop) {
            plugin.stop();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var _iterator7 = _createForOfIteratorHelper(this.plugins.keys()),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var key = _step7.value;
          this.plugins.delete(key);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      this.particles.linksColors = new Map();
      delete this.particles.grabLineColor;
      delete this.particles.linksColor;
    }
  }, {
    key: "loadTheme",
    value: function loadTheme(name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.currentTheme = name;
                _context.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "start",
    value: function start() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator8, _step8, _step8$value, plugin;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.started) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return this.init();

              case 4:
                this.started = true;
                this.eventListeners.addListeners();

                if (this.interactivity.element instanceof HTMLElement && this.intersectionObserver) {
                  this.intersectionObserver.observe(this.interactivity.element);
                }

                _iterator8 = _createForOfIteratorHelper(this.plugins);
                _context2.prev = 8;

                _iterator8.s();

              case 10:
                if ((_step8 = _iterator8.n()).done) {
                  _context2.next = 20;
                  break;
                }

                _step8$value = _slicedToArray(_step8.value, 2), plugin = _step8$value[1];

                if (!(plugin.startAsync !== undefined)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return plugin.startAsync();

              case 15:
                _context2.next = 18;
                break;

              case 17:
                if (plugin.start !== undefined) {
                  plugin.start();
                }

              case 18:
                _context2.next = 10;
                break;

              case 20:
                _context2.next = 25;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](8);

                _iterator8.e(_context2.t0);

              case 25:
                _context2.prev = 25;

                _iterator8.f();

                return _context2.finish(25);

              case 28:
                this.play();

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 22, 25, 28]]);
      }));
    }
  }, {
    key: "addClickHandler",
    value: function addClickHandler(callback) {
      var _this3 = this;

      var el = this.interactivity.element;

      if (!el) {
        return;
      }

      var clickOrTouchHandler = function clickOrTouchHandler(e, pos) {
        if (_this3.destroyed) {
          return;
        }

        var pxRatio = _this3.retina.pixelRatio;
        var posRetina = {
          x: pos.x * pxRatio,
          y: pos.y * pxRatio
        };

        var particles = _this3.particles.quadTree.queryCircle(posRetina, _this3.retina.sizeValue);

        callback(e, particles);
      };

      var clickHandler = function clickHandler(e) {
        if (_this3.destroyed) {
          return;
        }

        var mouseEvent = e;
        var pos = {
          x: mouseEvent.offsetX || mouseEvent.clientX,
          y: mouseEvent.offsetY || mouseEvent.clientY
        };
        clickOrTouchHandler(e, pos);
      };

      var touchStartHandler = function touchStartHandler() {
        if (_this3.destroyed) {
          return;
        }

        touched = true;
        touchMoved = false;
      };

      var touchMoveHandler = function touchMoveHandler() {
        if (_this3.destroyed) {
          return;
        }

        touchMoved = true;
      };

      var touchEndHandler = function touchEndHandler(e) {
        var _a, _b, _c;

        if (_this3.destroyed) {
          return;
        }

        if (touched && !touchMoved) {
          var touchEvent = e;
          var lastTouch = touchEvent.touches[touchEvent.touches.length - 1];
          var canvasRect = (_a = _this3.canvas.element) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
          var pos = {
            x: lastTouch.clientX - ((_b = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.left) !== null && _b !== void 0 ? _b : 0),
            y: lastTouch.clientY - ((_c = canvasRect === null || canvasRect === void 0 ? void 0 : canvasRect.top) !== null && _c !== void 0 ? _c : 0)
          };
          clickOrTouchHandler(e, pos);
        }

        touched = false;
        touchMoved = false;
      };

      var touchCancelHandler = function touchCancelHandler() {
        if (_this3.destroyed) {
          return;
        }

        touched = false;
        touchMoved = false;
      };

      var touched = false;
      var touchMoved = false;
      el.addEventListener("click", clickHandler);
      el.addEventListener("touchstart", touchStartHandler);
      el.addEventListener("touchmove", touchMoveHandler);
      el.addEventListener("touchend", touchEndHandler);
      el.addEventListener("touchcancel", touchCancelHandler);
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var availablePlugins, _iterator9, _step9, _step9$value, id, plugin, _iterator10, _step10, _step10$value, drawer, _iterator11, _step11, _step11$value, _plugin, _iterator12, _step12, _step12$value, _plugin2;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.actualOptions = new Options_1.Options();
                this.actualOptions.load(this._options);
                this.retina.init();
                this.canvas.init();
                this.actualOptions.setResponsive(this.canvas.size.width, this.retina.pixelRatio, this._options);
                this.actualOptions.setTheme(this.currentTheme);
                this.canvas.initBackground();
                this.canvas.resize();
                this.duration = Utils_1.getRangeValue(this.actualOptions.duration);
                this.lifeTime = 0;
                this.fpsLimit = this.actualOptions.fpsLimit > 0 ? this.actualOptions.fpsLimit : 60;
                availablePlugins = Utils_1.Plugins.getAvailablePlugins(this);
                _iterator9 = _createForOfIteratorHelper(availablePlugins);

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    _step9$value = _slicedToArray(_step9.value, 2), id = _step9$value[0], plugin = _step9$value[1];
                    this.plugins.set(id, plugin);
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }

                _iterator10 = _createForOfIteratorHelper(this.drawers);
                _context3.prev = 15;

                _iterator10.s();

              case 17:
                if ((_step10 = _iterator10.n()).done) {
                  _context3.next = 24;
                  break;
                }

                _step10$value = _slicedToArray(_step10.value, 2), drawer = _step10$value[1];

                if (!drawer.init) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 22;
                return drawer.init(this);

              case 22:
                _context3.next = 17;
                break;

              case 24:
                _context3.next = 29;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](15);

                _iterator10.e(_context3.t0);

              case 29:
                _context3.prev = 29;

                _iterator10.f();

                return _context3.finish(29);

              case 32:
                _iterator11 = _createForOfIteratorHelper(this.plugins);
                _context3.prev = 33;

                _iterator11.s();

              case 35:
                if ((_step11 = _iterator11.n()).done) {
                  _context3.next = 46;
                  break;
                }

                _step11$value = _slicedToArray(_step11.value, 2), _plugin = _step11$value[1];

                if (!_plugin.init) {
                  _context3.next = 41;
                  break;
                }

                _plugin.init(this.actualOptions);

                _context3.next = 44;
                break;

              case 41:
                if (!(_plugin.initAsync !== undefined)) {
                  _context3.next = 44;
                  break;
                }

                _context3.next = 44;
                return _plugin.initAsync(this.actualOptions);

              case 44:
                _context3.next = 35;
                break;

              case 46:
                _context3.next = 51;
                break;

              case 48:
                _context3.prev = 48;
                _context3.t1 = _context3["catch"](33);

                _iterator11.e(_context3.t1);

              case 51:
                _context3.prev = 51;

                _iterator11.f();

                return _context3.finish(51);

              case 54:
                this.particles.init();
                this.particles.setDensity();
                _iterator12 = _createForOfIteratorHelper(this.plugins);

                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    _step12$value = _slicedToArray(_step12.value, 2), _plugin2 = _step12$value[1];

                    if (_plugin2.particlesSetup !== undefined) {
                      _plugin2.particlesSetup();
                    }
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }

              case 58:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[15, 26, 29, 32], [33, 48, 51, 54]]);
      }));
    }
  }, {
    key: "intersectionManager",
    value: function intersectionManager(entries) {
      if (!this.actualOptions.pauseOnOutsideViewport) {
        return;
      }

      var _iterator13 = _createForOfIteratorHelper(entries),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var entry = _step13.value;

          if (entry.target !== this.interactivity.element) {
            continue;
          }

          if (entry.isIntersecting) {
            this.play();
          } else {
            this.pause();
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  }]);

  return Container;
}();

exports.Container = Container;